import { z } from 'zod';
import { DataSetReference } from 'libs/end-to-end/src/types/databases/data-sets/data-set-reference';

export const FullPayCorrectionCopilotDefinition = z
  .object({
    copilotType: z.literal('pay-correction'),
    internalPayBenchmarkingReference: DataSetReference.optional(),
  })
  .describe('FullPayCorrectionCopilotDefinition');

export type FullPayCorrectionCopilotDefinition = z.infer<
  typeof FullPayCorrectionCopilotDefinition
>;

// We exclude any fields here that are data set references, since they cause a cache miss on the dependency due to the schema changing.
export const PayCorrectionCopilotDefinition =
  FullPayCorrectionCopilotDefinition.omit({
    internalPayBenchmarkingReference: true,
  }).describe('PayCorrectionCopilotDefinition');

export type PayCorrectionCopilotDefinition = z.infer<
  typeof PayCorrectionCopilotDefinition
>;
